export default __webpack_public_path__ + "static/media/AWS-Transit-Gateway.c4cad688.svg";